import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

/* ================= FETCH SETTINGS ================= */
export const fetchPolicy = createAsyncThunk(
    'policy/fetch',
    async (type, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `api/admin/settings?type=${type}`
            );

            return {
                type,
                data: response.data?.data || response.data
            };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || `Failed to fetch ${type}`
            );
        }
    }
);

/* ================= SAVE SETTINGS ================= */
export const savePolicy = createAsyncThunk(
    'policy/save',
    async ({ type, en, fr, notify_user }, { rejectWithValue }) => {
        try {
            const payload = {
                en,
                fr,
                notify_user
            };

            const response = await axiosInstance.patch(
                `api/admin/settings?type=${type}`,
                payload
            );

            return {
                type,
                data: response.data?.data || response.data
            };
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || `Failed to save ${type}`
            );
        }
    }
);

/* ================= SLICE ================= */
const policySlice = createSlice({
    name: 'policy',
    initialState: {
        policies: {
            /*
              about-us: {
                en: { title, content },
                fr: { title, content }
              }
            */
        },
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            /* ===== FETCH ===== */
            .addCase(fetchPolicy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPolicy.fulfilled, (state, action) => {
                state.loading = false;
                state.policies[action.payload.type] = action.payload.data;
            })
            .addCase(fetchPolicy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            /* ===== SAVE ===== */
            .addCase(savePolicy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(savePolicy.fulfilled, (state, action) => {
                state.loading = false;
                state.policies[action.payload.type] = action.payload.data;
            })
            .addCase(savePolicy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default policySlice.reducer;
